var React = require('react');

function TwitterX (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.27556 12.9694L1.4181 21.9985H4.89887L10.9132 15.069L16.2128 22L23 21.9627L14.3948 10.507L21.7383 2.03855L18.3135 2L12.7664 8.36427L8.02062 2.01039L1 2.00273L9.27556 12.9694ZM18.8894 19.9202L17.133 19.9146L5.06523 4.00947H6.95462L18.8894 19.9202Z","fill":"currentColor"}));
}

TwitterX.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = TwitterX;

TwitterX.default = TwitterX;
